/***
 * Created on 2024/1/9
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React from 'react';
import ModalDialog from "../common/modal_dialog/modalDialog";
import {useTranslation} from "react-i18next";
import {useMutation} from "@tanstack/react-query";
import {apiPost} from "../../service/api";

function PasswordWarning({...props}) {
    const { t } = useTranslation();

    const extendWarningMutation = useMutation({
        mutationFn: async () => await apiPost('/ajax/extend_password_warning', null),
        onSuccess: data => {
            const url = new URLSearchParams(location.search);
            if (url.has('state')) {
                location.href = url.get('state');
            }
            else {
                location.href = '/account'
            }
        }
    })

    const closeModal = () => {
        extendWarningMutation.mutate();
    }

    const onSubmit = () => {
        const url = new URLSearchParams(location.search);
        if (url.has('state')) {
            location.href = `/account/security?state=${encodeURIComponent(url.get('state'))}#change_passwd`;
        }
        else {
            location.href = '/account/security#change_passwd'
        }
    }

    return (
        <ModalDialog {...props}
                     title={t('@Consider changing your password@')}
                     submitAction={onSubmit}
                     closeModal={closeModal}
                     submitText={t('@Safety Comes First@')}
                     cancelText={t('@Do It Later@')}>
            <div className="dialog-content">
                <p>
                    {t('@Your security on QNAP Cloud Services is our top priority. We have discovered that it is been over 6 months since you changed your QID password. For you account security, please consider changing your password today.@')}
                </p>
            </div>
        </ModalDialog>
    );
}

export default PasswordWarning;